module.exports = __webpack_public_path__ + "img/cb3.e0c4ec41.jpg";